import { DEFAULT_PROFILE_IMAGE, resolveProfileImageSrc } from '../utils/profileImage'

/**
 * Account image: uses [src] when present; otherwise the default “no profile” asset.
 * Broken URLs fall back via onError.
 */
export default function ProfileAvatar({ src, alt = '', className }) {
  const resolved = resolveProfileImageSrc(src)
  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onError={(e) => {
        const el = e.currentTarget
        if (el.dataset.fallback === '1') return
        el.dataset.fallback = '1'
        el.src = DEFAULT_PROFILE_IMAGE
      }}
    />
  )
}
